/**
 * @file Datil.co main file
 * @author Denny K. Schuldt
 * @copyright Copyright 2017, Datilmedia S.A.
 */

import SignUp from './signup';
import * as Services from './services.js';

const connect_plans = {
    peya_guayaquil: {fee: 1,
                     code: 'peya-guayaquil'},
    peya_cuenca: {fee: 1,
                  code: 'peya-cuenca'},
    peya_riobamba: {fee: 1,
                    code: 'peya-riobamba'},
    peya_quito: {fee: 1,
                 code: 'peya-quito'},
    peya_cayambe: {fee: 1,
                   code: 'peya-cayambe'},
    peya_latacunga: {fee: 1,
                     code: 'peya-latacunga'},
    peya_santa_elena: {fee: 1,
                       code: 'peya-santa-elena'},
    peya_valle_de_los_chillos: {fee: 1,
                                code: 'peya-valle-de-los-chillos'},
    peya_manta: {fee: 1,
                 code: 'peya-manta'},
    peya_machala: {fee: 1,
                 code: 'peya-machala'},
    peya_ambato: {fee: 1,
                  code: 'peya-ambato'},
    peya_santo_domingo: {fee: 1,
                         code: 'peya-santo-domingo'},
    peya_portoviejo: {fee: 1,
                      code: 'peya-portoviejo'},
    peya_loja: {fee: 1,
                code: 'peya-loja'},
    peya_ibarra: {fee: 1,
                  code: 'peya-ibarra'},
    peya_esmeraldas: {fee: 1,
                      code: 'peya-esmeraldas'},
    peya_quevedo: {fee: 1,
                   code: 'peya-quevedo'}
};

const plans = [
    {
        code: "lite",
        name: "Lite de 50 comprobantes mensuales",
        fee: "8",
        mainFeature: "Hasta 50 comprobantes"
    },
    {
        code: "plus",
        name: "Plus de 100 comprobantes mensuales",
        fee: "14",
        mainFeature: "Hasta 100 comprobantes"
    },
    {
        code: "pro",
        name: "Pro de 1000 comprobantes mensuales",
        fee: "34",
        mainFeature: "Hasta 1000 comprobantes"
    },
    {
        code: "acqualuxe",
        name: "Plan socio Acqualuxe",
        fee: "0",
        mainFeature: "Los comprobantes son pagados por Acqualuxe"
    },
    {
        code: "cabify",
        name: "Plan socio Cabify",
        fee: "0",
        mainFeature: "Los comprobantes son pagados por Cabify"
    },
    {
        code: "peya",
        name: "Plan para Riders PedidosYa",
        fee: "1",
        mainFeature: "El valor del plan es $1/mes e incluye 5 documentos mensuales."
    },
    {
        code: "free",
        name: "Plan gratis de 10 comprobantes mensuales",
        fee: "0",
        mainFeature: "No tiene costo"
    },
    {
        code: "comprasec",
        name: "Plan para clientes ComprasEC",
        fee: "0",
        mainFeature: "No tiene costo"
    },
    {
        code: "practisis",
        name: "Plan para clientes Practisis",
        fee: "0",
        mainFeature: "No tiene costo"
    },
    {
        code: "contapp",
        name: "Plan para clientes ContApp",
        fee: "0",
        mainFeature: "No tiene costo"
    },
    {
        code: "idukay",
        name: "Plan para clientes Idukay",
        fee: "0",
        mainFeature: "No tiene costo para los clientes."
    },
    {
        code: "max",
        name: "Plan para socios Max International",
        fee: "0",
        mainFeature: "No tiene costo para los clientes."
    },
    {
        code: "micontador",
        name: "Plan para clientes Micontador.ec",
        fee: "0",
        mainFeature: "No tiene costo."
    },
    {
        code: "reinec",
        name: "Plan para clientes Reinec",
        fee: "0",
        mainFeature: "No tiene costo."
    },
    {
        code: "delivereo",
        name: "Plan para couriers Delivereo",
        fee: "0",
        mainFeature: "No tiene costo."
    },
    {
        code: "polymath",
        name: "Plan para clientes Polymath",
        fee: "0",
        mainFeature: "No tiene costo."
    },
    {
        code: "brainbox",
        name: "Plan para clientes Brainbox",
        fee: "0",
        mainFeature: "No tiene costo."
    },
    {
        code: "paredes",
        name: "Plan para clientes Paredes & Paredes",
        fee: "0",
        mainFeature: "No tiene costo."
    },
    {
        code: "mini",
        name: "Mini de 10 comprobantes mensuales",
        fee: "25",
        mainFeature: "Hasta 10 comprobantes al mes"
    },
    {
        code: "lite-y",
        name: "Lite de 8 comprobantes mensuales (anual)",
        fee: "80",
        mainFeature: "Hasta 50 comprobantes al mes"
    },
    {
        code: "plus-y",
        name: "Plus de 100 comprobantes mensuales (anual)",
        fee: "140",
        mainFeature: "Hasta 100 comprobantes al mes"
    },
    {
        code: "pro-y",
        name: "Pro de 1000 comprobantes mensuales (anual)",
        fee: "340",
        mainFeature: "Hasta 1000 comprobantes al mes"
    },
    {
        code: "pago46",
        name: "Plan para asociados Pago46",
        fee: "0",
        mainFeature: "No tiene costo"
    },
    {
        code: "justo",
        name: "Plan para asociados Justo",
        fee: "0",
        mainFeature: "No tiene costo"
    },
    {
        code: "simplesas",
        name: "Plan para clientes SimpleSAS",
        fee: "0",
        mainFeature: "No tiene costo"
    },
    {
        code: "meet2go",
        name: "Plan para clientes Meet2go",
        fee: "0",
        mainFeature: "No tiene costo"
    },
    {
        code: "saga",
        name: "Plan para clientes Saga Latam",
        fee: "0",
        mainFeature: "No tiene costo"
    },
    {
        code: "konnet",
        name: "Plan para clientes Konnet",
        fee: "0",
        mainFeature: "No tiene costo"
    },
    {
        code: "welssoft",
        name: "Plan para clientes Welssoft",
        fee: "0",
        mainFeature: "No tiene costo"
    },
    {
        code: "devcomm",
        name: "Plan para clientes Devcomm",
        fee: "0",
        mainFeature: "No tiene costo"
    },
    {
        code: "iss",
        name: "Plan para clientes ISS",
        fee: "0",
        mainFeature: "No tiene costo"
    },
    {
        code: "formaccion",
        name: "Plan para clientes Formacción",
        fee: "0",
        mainFeature: "No tiene costo"
    },
    {
        code: "ist",
        name: "Plan para clientes IST",
        fee: "0",
        mainFeature: "No tiene costo"
    },
    {
        code: "effisystems",
        name: "Plan para clientes Effisystems",
        fee: "0",
        mainFeature: "No tiene costo"
    },
    {
        code: "bracco",
        name: "Plan para clientes de Marjorie Bracco",
        fee: "0",
        mainFeature: "No tiene costo"
    },
    {
        code: "goldproyec",
        name: "Plan para clientes de Goldproyec",
        fee: "0",
        mainFeature: "No tiene costo"
    },
    {
        code: "descarga",
        name: "Registro para descarga de documentos",
        fee: "0",
        mainFeature: "Sin costo"
    },
    {
        code: "doctoranytime",
        name: "Plan para clientes de DoctorAnytime",
        fee: "0",
        mainFeature: "Sin costo"
}];

/*
 * @source http://w3lessons.info/2013/02/25/how-to-get-url-parameters-values-using-jquery/
 */
window.getUrlParams = () => {
    var vars = [], hash;
    var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
    for(var i = 0; i < hashes.length; i++)
    {
        hash = hashes[i].split('=');
        vars.push(hash[0]);
        vars[hash[0]] = hash[1];
    }
    return vars;
}

/**
 * inViewport jQuery plugin by Roko C.B.
 * http://stackoverflow.com/a/26831113/383904
 * Returns a callback function with an argument holding
 * the current amount of px an element is visible in viewport
 * (The min returned value is 0 (element outside of viewport)
 */
;(function($, win) {
    $.fn.inViewport = function(cb) {
        return this.each(function(i,el) {
            function visPx(){
                var elH = $(el).outerHeight(),
                    H = $(win).height(),
                    r = el.getBoundingClientRect(), t=r.top, b=r.bottom;
                return cb.call(el, Math.max(0, t>0? Math.min(elH, H-t) : (b<H?b:H)));
            }
            visPx();
            $(win).on("resize scroll", visPx);
        });
    };
}(jQuery, window));

/**
 *
 */
var navTransitionScrollOffset = 60;
var navScrollSpy = function () {
    if ($(".home").length) {
        var scrollTop = $(window).scrollTop();
        if (scrollTop > navTransitionScrollOffset) {
            $(".home").addClass("is-scrolled");
            $(".home header > .navbar").removeClass("navbar-inverse");
        } else {
            $(".home").removeClass("is-scrolled");
            $(".home header > .navbar").addClass("navbar-inverse");
        }
    } else {
        $("header > .navbar").removeClass("navbar-inverse");
    }
}

/**
 *
 */
var windowSizeListener = function () {
    $(window).resize(function() {
        if ($("#intro-datil").size()) { // isHome?
            $("#intro-datil").css({"height": $(window).height()});
        }
        $("body").css({marginBottom: $("footer").outerHeight()});
    });
    homeIntroHeight();
}

/**
 *
 */
var homeIntroHeight = function() {
    var introHeight;
    $('.home-intro').inViewport(function(px) {
        introHeight = px;
    });
    if ($(window).innerHeight() > introHeight) {
        $('.home-intro').css({
            'height': $(window).innerHeight()
        });
    }
};

/**
 *
 */
const scrollToTop = () => {
    $("html, body").animate({ scrollTop: 0 }, "slow");
};

const openIntercomChat = function() {
    var urlParams = new URLSearchParams(location.search);
    if (urlParams.has('openchat')) {
        Intercom('showNewMessage', '');
    }
};

$(document).ready(function() {
    openIntercomChat();
    var path = window.location.pathname;
    windowSizeListener();
    navScrollSpy();
    $("#intro-datil").css({"height": $(window).height()});
    $('body').css('margin-bottom', '0');
    $(window).scroll(() => navScrollSpy());
    $(window).resize(() => $('body').css('margin-bottom', '0'));

    $('.arrow-down').click(() => $('html, body').animate({
        scrollTop: window.innerHeight
    }, 600));

    // RECEIPTS SEARCH
    if ($("#app").size()) {
        datil.Views.app();
    }
    if ($('.searchid').length) {
        ga('send', 'event', 'action', 'search', 'Consultando comprobante');
    }
    $('.search-form #searchid').on('input', function(e) {
        const url = '/consultas/'+ e.target.value;
        $('.search-form').attr('action', url);
    });

    // SERVICES PAGE
    if ($("#services").length) {
        Services.init();
    }

    // SIGNUP FORM
    if ($("#signup-form").length) {
        SignUp(document.getElementById("signup-form"), $("#signup-form").data());
    }
    if (window.getUrlParams().plan_fee) {
        $('#pricing-slide').carousel('next');
    }

    // PRICING PAGE
    $('[data-slide="next"]').click(function(evt) {
        var selectedPlanIdx = parseInt($(this).data('plan'), 10);
        var selectedPlan = plans[selectedPlanIdx];
        scrollToTop();
        window.signup.store.dispatch(
            window.signup.actions.changePlanFee({ planFee: selectedPlan.fee })
        );
        window.signup.store.dispatch(
            window.signup.actions.changePlanCode({ planCode: selectedPlan.code })
        );
        $('#pricing-slide').carousel('next');
    });
    $('[data-slide="prev"]').click(function () {
        $('#pricing-slide').carousel('prev');
    });

    // CONNECT PAGE
    $('[data-slide="next-connect"]').click(function(evt) {
        var selectedPlanIdx = document.getElementById("connectPlan").value;
        var selectedPlan = connect_plans[selectedPlanIdx];
        scrollToTop();
        window.signup.store.dispatch(
            window.signup.actions.changePlanFee({ planFee: selectedPlan.fee })
        );
        window.signup.store.dispatch(
            window.signup.actions.changePlanCode({ planCode: selectedPlan.code })
        );
        $('#pricing-slide').carousel('next');
    });
    $('[data-slide="prev"]').click(function () {
        $('#pricing-slide').carousel('prev');
    });

});
